export { FinancialInstitutionWhereActivityOccurred } from './FinancialInstitutionWhereActivityOccurred'
